import { defineMessage } from 'services/localization';

export const messages = {
    endStepBubbleTextApproveInXero: defineMessage('authorisation_in_xero'),
    endStepBubbleTextPo: defineMessage('creation_authorisation_in_xero'),
    endStepBubbleTextAmaxPayXeroBatchPayment: defineMessage('creation_in_xero'),
    endStepBubbleTextBillBatchPayment: defineMessage('push_to_xero'),
    endStepBubbleTextAirwalletBatchPayment: defineMessage('creation_in_xero'),
    endStepDescriptionApproveInXero: defineMessage('pluraltemplatename_will_d_in_xero_upon_approval'),
    endStepDescriptionPo: defineMessage('purchase_orders_will_be_ero_upon_final_approval'),
    endStepDescriptionAmaxPayXeroBatchPayment: defineMessage('bill_payments_will_be_c_each_successful_payment'),
    endStepDescriptionBillBatchPayment: defineMessage('bulk_payment_will_be_pu_in_account_transactions'),
    endStepDescriptionAirwallexBatchPayment: defineMessage('bill_payments_will_be_c_ent_made_with_airwallex'),
    accountTransactionsButtonText: defineMessage('go_to_bank_accounts'),
    endStepBubbleTextQuote: defineMessage('creation_authorisation_in_xero'),
    endStepDescriptionQuote: defineMessage('after_their_final_appro_ated_authorised_in_xero'),
    endStepBubbleTextManualJournal: defineMessage('creation_authorisation_in_xero'),
    endStepDescriptionManualJournal: defineMessage('after_their_final_appro_ated_authorised_in_xero_1'),
};
